export const SET_ADDRESS = 'SET_ADDRESS';

export const setAddress = address => ({type: SET_ADDRESS, value: {address}});
